import { Injectable } from '@angular/core';
import { ServiceAppointment } from './models';

@Injectable()
export class AppointmentDataService {
  saveModel: ServiceAppointment.SaveModel = {
    scheduleDate: new Date(),
  } as ServiceAppointment.SaveModel;
}
